import SearcherContainer from './SearcherContainer';

export default SearcherContainer;
